import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { Reveal, SectionHeading, SectionCta } from "./Reveal";

const MOMENTS = [
  { time: "7:40 AM", text: "The inquiry that came in at 11 last night already has a reply. She answered it before her coffee." },
  { time: "9:15 AM", text: "A nervous first-time caller asks what lipo costs. She does not get a price and a hang-up. She gets asked what she is hoping to fix, then offered Thursday at two or Friday at eleven." },
  { time: "10:30 AM", text: "Two weekend Instagram DMs about financing. Answered in your approved language. Both moved into the pipeline." },
  { time: "12:00 PM", text: "Deposit collected on tomorrow's consult, per your policy. Confirmation sent. You are with a patient and never touched your phone." },
  { time: "2:20 PM", text: "An inquiry that went cold two weeks ago got a follow-up yesterday. She just replied. She is on the schedule." },
  { time: "4:00 PM", text: "Your coordinator is out sick. The backup has been running the desk since eight. You did not notice." },
  { time: "6:05 PM", text: "The KPI scorecard lands in your inbox. Inquiries in, answer rate, speed-to-lead, booked, showed." },
  { time: "Tonight", text: "You go home. Nobody needs you to check the voicemail." },
];

export const OrdinaryDay = () => {
  const timelineRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: timelineRef,
    offset: ["start 75%", "end 55%"],
  });

  return (
    <section data-testid="ordinary-day-section" className="py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <SectionHeading
              eyebrow="What changes"
              title={
                <>
                  An ordinary Tuesday, <span className="italic text-champagne">once the Engine is running.</span>
                </>
              }
              copy="Nothing dramatic happens. That is the entire point."
            />
          </div>
        </div>
        <div className="lg:col-span-8">
          <div className="relative pl-10" ref={timelineRef}>
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-black/10" />
            <motion.div
              style={{ scaleY: scrollYProgress }}
              className="absolute left-[7px] top-2 bottom-2 w-px origin-top bg-gradient-to-b from-champagne via-champagne/50 to-champagne"
            />
            {MOMENTS.map((m, i) => (
              <Reveal key={i} delay={i * 0.05} y={24}>
                <div className="relative pb-10 last:pb-0 group" data-testid={`day-moment-${i}`}>
                  <span className="absolute -left-10 top-1.5 h-[15px] w-[15px] rounded-full border-2 border-champagne/60 bg-white group-hover:bg-champagne group-hover:shadow-[0_0_14px_rgba(61,165,221,0.5)] transition-all duration-500" />
                  <p className="font-mono text-sm text-champagne">{m.time}</p>
                  <p className="mt-2 text-base md:text-lg text-zinc-600 font-light leading-relaxed max-w-2xl">{m.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <SectionCta id="ordinary-day" label="Give me my evenings back" />
        </div>
      </div>
    </section>
  );
};
